import classNames from "classnames";
import { HeaderGroup } from "PFComponents/table/table.types";
import { RefObject } from "react";

import { TableData } from "../table";
import css from "../table.module.scss";
import { ColumnHeader } from "./column_header";

type TableHeaderRowsProps<T extends TableData> = {
  theadRef?: RefObject<HTMLTableSectionElement | null>;
  headerGroups: HeaderGroup<T>[];
  compact?: boolean;
  displayGrid?: boolean;
  enableMultiRowSelection?: boolean;
};

export const TableHeaderRows = <T extends TableData>({
  theadRef,
  headerGroups,
  compact,
  displayGrid,
  enableMultiRowSelection
}: TableHeaderRowsProps<T>) => (
  <thead ref={theadRef} className={classNames(css.header, { [css.displayGrid]: displayGrid })}>
    {headerGroups.map(({ id, headers }) => (
      <tr key={id} className={css.row}>
        {headers.map((header) => (
          <ColumnHeader
            key={header.id}
            header={header}
            compact={compact}
            enableMultiRowSelection={enableMultiRowSelection}
          />
        ))}
      </tr>
    ))}
  </thead>
);
